import script from "./AdvisoryProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvisoryProgram.vue?vue&type=script&setup=true&lang=js"

import "./AdvisoryProgram.vue?vue&type=style&index=0&id=b00f33fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b00f33fa"]])

export default __exports__